import React, { useState, useEffect, useContext } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Loader } from 'quantux-ui';
import CaseScheduleContext from '../case-schedule/case-schedule-context';
import { BASE_URL, titleCase } from '../../utils';
import PayerCard from '../patient-dashboard/payer-card';
import { gray, blue, salmon } from '../../theme';

const piIcon = (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Zm12.071-2L3.5 4.857v8.572A8.57 8.57 0 0 0 12.071 22a8.57 8.57 0 0 0 8.572-8.571V4.857L12.07 2Zm.003 18.393a6.965 6.965 0 0 0 6.964-6.964V6.063l-6.964-2.456-6.965 2.456v7.366a6.965 6.965 0 0 0 6.965 6.964Zm1.101-5.318V16h-4v-.925h1.465V10.86c0-.167.005-.338.015-.515l-1.04.87a.456.456 0 0 1-.18.09.457.457 0 0 1-.3-.05.318.318 0 0 1-.09-.085l-.39-.535L10.86 8.76h1.015v6.315h1.3Zm2.957-8.095a2.222 2.222 0 0 0-.828-.148c-.307 0-.585.05-.836.148-.25.099-.465.239-.644.42a1.906 1.906 0 0 0-.412.664 2.526 2.526 0 0 0-.144.876c0 .325.048.619.144.88.099.261.236.484.412.668.179.184.393.325.644.424.25.099.53.148.836.148.304 0 .58-.05.828-.148.25-.099.464-.24.64-.424a1.87 1.87 0 0 0 .412-.668c.096-.261.144-.555.144-.88 0-.323-.048-.615-.144-.876a1.794 1.794 0 0 0-1.052-1.084Zm-.072 2.976c-.163.23-.415.344-.756.344-.347 0-.604-.115-.772-.344-.165-.232-.248-.568-.248-1.008 0-.44.083-.776.248-1.008.168-.235.425-.352.772-.352.341 0 .593.116.756.348.165.232.248.57.248 1.012 0 .443-.083.779-.248 1.008Z"
      fill="#96C8FF"
    />
  </svg>
);

const InsuranceInfo = (props) => {
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [payerData, setPayerData] = useState({});

  const { patientData, insuranceType } = props;

  // const { readOnlyMode = false } = useContext(CaseScheduleContext);
  let readOnlyMode = false;
  const context = useContext(CaseScheduleContext);
  if (context) {
    readOnlyMode = context.readOnlyMode;
  }

  // Styles
  const styles = StyleSheet.create({
    drawerBannerCameraIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: gray[500],
      color: 'white',
      position: 'absolute',
      right: '0px',
      bottom: '8px',
      fontSize: '11px',
      width: '24px',
      height: '24px',
      cursor: 'pointer',
      borderRadius: '50%'
    },
    whiteText: {
      color: 'white'
    }
  });

  console.log('--------- INSURANCE INFO ----------');
  console.log(patientData);
  console.log(insuranceType);
  let insuranceData = {};
  let payerRoute = '';
  let insuranceIdFrontScanUrl = null;
  let insuranceIdBackScanUrl = null;

  switch (insuranceType) {
    case 'secondary':
      payerRoute = 'getPatientSecondaryInsuranceData';
      insuranceData = patientData.secondaryInsurance || {};
      insuranceIdFrontScanUrl = patientData.secondaryInsuranceCardFrontScan;
      insuranceIdBackScanUrl = patientData.secondaryInsuranceCardBackScan;
      break;
    case 'tertiary':
      payerRoute = 'getPatientTertiaryInsuranceData';
      insuranceData = patientData.tertiaryInsurance || {};
      insuranceIdFrontScanUrl = patientData.tertiaryInsuranceCardFrontScan;
      insuranceIdBackScanUrl = patientData.tertiaryInsuranceCardBackScan;
      break;
    case 'primary':
    default:
      payerRoute = 'getPatientPrimaryInsuranceData';
      insuranceData = patientData.primaryInsurance || {};
      insuranceIdFrontScanUrl = patientData.primaryInsuranceCardFrontScan;
      insuranceIdBackScanUrl = patientData.primaryInsuranceCardBackScan;
      break;
  }

  let dobMonth = 1;
  let dobDate = 1;
  let dobYear = 2022;

  const tmp = insuranceData.memberDob.split('T');
  const tmp2 = tmp[0].split('-');
  dobYear = +tmp2[0];
  dobMonth = +tmp2[1] - 1;
  dobDate = +tmp2[2];

  const loadPayerData = () => {
    setIsLoadingData(true);
    const url = new URL(`${BASE_URL}/patients/${payerRoute}`);
    const params = { patientId: props.patientData._id };
    url.search = new URLSearchParams(params).toString();

    fetch(url)
      .then(response => response.text())
      .then(result => {
        const reqData = JSON.parse(result);
        setIsLoadingData(false);
        if (reqData.payerData && Object.keys(reqData.payerData).length > 0) {
          setPayerData(reqData.payerData);
        }
      })
      .catch(error => console.log('error', error));
  };

  useEffect(() => {
    loadPayerData();
  }, [props.patientData, props.insuranceType]);

  return (
    <div
      className={props.className}
      style={{
        overflowY: 'auto',
        width: '375px',
        position: 'relative'
      }}
    >
      {isLoadingData &&
        <div
          style={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            background: blue[900],
            opacity: '0.95',
            zIndex: '5000'
          }}
        >
          <Loader iconType="cog" iconSize="5x" text="Loading Data..." />
        </div>
      }

      <div className='fx fx__v-center'>
        {piIcon}
        <div
          className='ml-2'
          style={{
            color: 'white',
            fontWeight: 'bold'
          }}
        >
          {props.headingText}
          <i
            className='ml-4 fa fa-pencil'
            onClick={() => {
              if (!readOnlyMode) {
                props.onEditInsuranceInfo();
              }
            }}
          />
        </div>
      </div>
      {Object.keys(payerData).length > 0 &&
        <PayerCard
          selectedPayer={payerData}
          showEllipsis={false}
          style={{ width: `${props.width}px` }}
          onDelete={props.onDeletePayer}
        />
      }
      {/* Member relation to patient, firstName, middleName, lastName, dob etc */}
      <div className='mt-4'>
        {/* {Object.keys(payerData).length > 0 && } */}
        {(insuranceData.patientRelationToMember && insuranceData.patientRelationToMember.length > 0) &&
          <>
            {/* Memeber/Subscriber Name */}
            <div className='fx mt-2'>
              <div>Member/Subscriber:</div>
              {insuranceData.memberFirstName && insuranceData.memberFirstName.length > 0 && insuranceData.memberLastName && insuranceData.memberLastName.length > 0
                ? <div className={`ml-2 ${css(styles.whiteText)}`}>
                    {`${titleCase(insuranceData.memberFirstName)}${insuranceData.memberMiddleName && insuranceData.memberMiddleName.length > 0 ? ` ${titleCase(insuranceData.memberMiddleName)}` : ''} ${titleCase(insuranceData.memberLastName)}`}
                  </div>
                : <div className='ml-2' style={{ fontSize: '14px', color: salmon[500] }}>Required</div>
              }
            </div>
            {/* Subscriber DOB */}
            <div className='fx mt-2'>
              <div> Subscriber DOB</div>
              {!insuranceData.isMemberDobPristine
                ? <div className={`ml-2 ${css(styles.whiteText)}`}>{`${dobMonth + 1}/${dobDate}/${dobYear}`}</div>
                : <div style={{ fontSize: '14px', color: salmon[500] }}>Required</div>
              }
            </div>
            {/* Patient Relation to Subscriber */}
            <div className='fx mt-2'>
              <div>Patient Relation To Subscriber:</div>
              <div className={`ml-2 ${css(styles.whiteText)}`}>
                {insuranceData.patientRelationToMember}
              </div>
            </div>
            {/* Policy # and Authorization # */}
            <div className='fx mt-2'>
              <div>Policy #:
                <span className={`ml-2 ${css(styles.whiteText)}`}>
                  {insuranceData.policyNumber && insuranceData.policyNumber !== ''
                    ? <span>{insuranceData.policyNumber}</span>
                    : <span style={{ fontSize: '14px', color: salmon[500] }}>Required</span>
                  }
                </span>
              </div>
              <div className='ml-2'>Authorization #:
                <span className={`ml-2 ${css(styles.whiteText)}`}>
                  {insuranceData.authorizationNumber && insuranceData.authorizationNumber !== ''
                    ? <span>{insuranceData.authorizationNumber}</span>
                    : <span style={{ fontSize: '14px', color: salmon[500] }}>Required</span>
                  }
                </span>
              </div>
            </div>
            {/* Group # */}
            <div className='fx mt-2'>
              <div>Group #:</div>
              <div className={`ml-2 ${css(styles.whiteText)}`}>
                {insuranceData.groupNumber && insuranceData.groupNumber !== ''
                  ? <div>{insuranceData.groupNumber}</div>
                  : <div style={{ fontSize: '14px', color: salmon[500] }}>
                    Required
                  </div>
                }
              </div>
            </div>
          </>
        }
      </div>
      {(insuranceData.patientRelationToMember && insuranceData.patientRelationToMember.length > 0) &&
        <>
          {/* Insurnace Card - Front */}
          <div className='mt-4'>
            <div className='fx'>
              {piIcon}
              <div className='ml-2'>
                Insurance Card (Front)
              </div>
            </div>
            <div style={{ position: 'relative' }}>
              <img
                className='mt-2'
                src={insuranceIdFrontScanUrl || 'https://quantumtrader.s3.amazonaws.com/default_insurance.jpg'}
                style={{
                  width: '343px',
                  maxWidth: '343px',
                  height: 'auto'
                }}
              />
            </div>
          </div>
          {/* Primary Insurnace Card - Back */}
          <div className='mt-4'>
            <div className='fx'>
              {piIcon}
              <div className='ml-2'>
                Insurance Card (Back)
              </div>
            </div>
            <div style={{ position: 'relative' }}>
              <img
                className='mt-2'
                src={insuranceIdBackScanUrl || 'https://quantumtrader.s3.amazonaws.com/default_insurance.jpg'}
                style={{
                  width: '343px',
                  maxWidth: '343px',
                  height: 'auto'
                }}
              />
            </div>
          </div>
        </>
      }
    </div>
  );
};

InsuranceInfo.defaultProps = {
  className: 'p-2',
  width: 359
};

export default InsuranceInfo;
